import React from "react";
import { useFieldArray } from "react-hook-form";
import Input from "../Input/Input";

import styles from "./AcademicActivites.module.css";

const BookChapters = ({ register, control, errors, disabled }) => {
  const { fields, append, remove } = useFieldArray({
    control,
    name: "bookChapters",
  });

  React.useEffect(() => {
    if (fields.length === 0) {
      append({
        chapterTitle: "",
        bookTitle: "",
        year: "",
        DOI: "",
        publisher: "",
      });
    }
  }, [fields, append]);

  return (
    <div className={styles.borderBox}>
      <div className={styles.heading}>
        <h2>3. Book Chapters</h2>

      </div>
      {fields.map((item, idx) => (
        <div className={styles.grid5} key={item.id}>
          <Input
            label="Chapter Title"
            name={`bookChapters[${idx}].chapterTitle`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Book Title"
            name={`bookChapters[${idx}].bookTitle`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Year"
            name={`bookChapters[${idx}].year`}
            register={register}
            errors={errors}
            year
            disabled={disabled}
          />
          <Input
            label="DOI (If any)"
            name={`bookChapters[${idx}].DOI`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          <Input
            label="Publisher"
            name={`bookChapters[${idx}].publisher`}
            register={register}
            errors={errors}
            disabled={disabled}
          />
          {idx > 0 && !disabled && (
            <button
              type="button"
              className={styles.remove}
              onClick={() => remove(idx)}
            >
              X
            </button>
          )}
        </div>
      ))}

      <div className={styles.buttonOuter}>
        <div></div>

        {!disabled && (
          <button
            type="button"
            className={styles.button}
            onClick={() =>
              append({
                chapterTitle: "",
                bookTitle: "",
                year: "",
                DOI: "",
                publisher: "",
              })
            }
          >
            + Add More
          </button>
        )}
      </div>

    </div>
  );
};

export default BookChapters;
